import { useTranslation } from "react-i18next";
import { Box, Typography, Button } from "@mui/material";

import HeroImg from "../../assets/images/Home/HeroImg.png";
import HeroBG from "../../assets/images/Home/HeroBG.png";

const HeroSection = ({
  scrollToRegisterEntity,
  scrollToWaitingList,
}: {
  scrollToRegisterEntity: () => void;
  scrollToWaitingList: () => void;
}) => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  return (
    <Box
      component="section"
      sx={{
        background: `url(${HeroBG})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "214px 0 117px",
          width: "95%",
          maxWidth: "1240px",
          margin: "0 auto",
          rowGap: "40px",
          flexDirection: {
            xs: "column",
            lg: "row",
          },
        }}
      >
        <Box sx={{ maxWidth: "575px", width: "100%", display: "flex", flexDirection: "column", rowGap: "26px" }}>
          <Typography
            component="h4"
            sx={{
              fontFamily: "HeadingNowVarTrial",
              fontSize: "28px",
              fontStyle: "normal",
              fontWeight: 750,
              lineHeight: {
                xs: "normal",
                lg: "130%",
              },
              textTransform: "uppercase",
              background: "linear-gradient(180deg, #FFF 0%, #B8C2CE 100%)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            {t("pages.home.sportsManagementSystem")}
          </Typography>
          <Typography
            component="h2"
            sx={{
              fontFamily: "HeadingNowVarTrial",
              fontSize: "40px",
              fontStyle: "normal",
              fontWeight: 750,
              lineHeight: "130%",
              textTransform: "uppercase",
              background: "linear-gradient(180deg, #FFF 0%, #B8C2CE 100%)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            {t("pages.home.unlockPotential")}
          </Typography>
          <Typography
            component="p"
            sx={{
              //   fontFamily: "Inter",
              // fontFamily: "Almarai",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "26px",
              background: "linear-gradient(180deg, #FFF 0%, #B8C2CE 100%)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            {t("pages.home.streamlineManagement")}
          </Typography>
          <Box
            sx={{
              display: "flex",
              gap: "26px",
              flexDirection: {
                xs: "column",
                lg: "row",
              },
            }}
          >
            <Button
              onClick={scrollToRegisterEntity}
              sx={{
                width: {
                  xs: "100%",
                  lg: "210px",
                },
                background: "var(--Green---100, #008B07) !important",
                border: "none",
                borderRadius: "50px",
                padding: "10px 0",
                textAlign: "center",
                color: "var(--Base-White, #FFF)",
                fontFamily: "HeadingNowVarTrial",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "24px",
              }}
            >
              {t("pages.home.requestDemo")}
            </Button>
            <Button
              onClick={scrollToWaitingList}
              sx={{
                width: {
                  xs: "100%",
                  lg: "210px",
                },
                background: "transparent !important",
                border: "1px solid #BAEDBD !important",
                color: "var(--Secondary-Mint, #BAEDBD) !important",
                borderRadius: "50px",
                padding: "10px 0",
                textAlign: "center",
                fontFamily: "HeadingNowVarTrial",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "24px",
              }}
            >
              {t("pages.home.registerEntity")}
            </Button>
          </Box>
        </Box>

        <Box
          sx={{
            position: "relative",
            left: {
              xs: "unset",
              lg: currentLang === "en" ? "29px" : "unset",
            },
            right: {
              xs: "unset",
              lg: currentLang === "ar" ? "29px" : "unset",
            },
          }}
        >
          <img
            src={HeroImg}
            alt="A laptop and mobile with goalngo website open"
            width="686.2px"
            height="432.5px"
            style={{
              maxWidth: "100%",
              height: "auto",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default HeroSection;
